module.exports = __webpack_public_path__ + "static/media/folder.1f35e12e.svg";